export default __webpack_public_path__ + "static/media/certificate.5c588625.png";